import { defineAction } from '~/prix'
import { z } from 'zod'
import protocolDeleteAction from './protocolDelete.action.json' with { type: 'json' }

const protocolDeleteDefinition = defineAction({
  ...protocolDeleteAction,

  input: z.object({
    id: z.string().uuid(),
  }),
  output: z.object({}),
})

export default protocolDeleteDefinition
